import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Percent, Currency } from '../../../../../App/Components/Format'
import Spinner from '../../../../../App/Components/Spinner/Spinner'
import { useAppSelector } from '../../../../../App/Hooks/reduxHooks'
import { ITargetPerson } from '../../../Client/ITarget'

import { IProps } from './IProps'
import OverviewPerson from './OverviewPerson/OverviewPerson'
import style from './style.scss'

const OverviewTarget = ({ target, personRevenues }: IProps) => {
  const { t } = useTranslation()

  const [isDropDownVisible, setIsDropDownVisible] = useState(true)

  const [isLoading] = useAppSelector(state => {
    if (!state) return [true]
    return [state.hr.personTargets.loading]
  })

  const toggleDropDownVisibility = () => {
    isDropDownVisible ? setIsDropDownVisible(false) : setIsDropDownVisible(true)
  }

  const calculateTotalPerPerson = (person: ITargetPerson) => {
    return personRevenues.reduce((accumulator, currentValue) => {
      return currentValue.personId === person.id
        ? accumulator + currentValue.amount
        : accumulator
    }, 0)
  }

  const calculateSucceedPerPerson = (person: ITargetPerson): boolean =>
    calculateTotalPerPerson(person) > target.amount

  let peopleSucceeded = 0
  target.persons.forEach((person: ITargetPerson) => {
    if (true === calculateSucceedPerPerson(person)) {
      peopleSucceeded++
    }
  })

  let total = 0
  target.persons.forEach(person => {
    total = total + calculateTotalPerPerson(person)
  })

  if (true === isLoading) {
    return <Spinner />
  }

  return (
    <li className={style.overviewElement}>
      <div className={style.overviewTop}>
        <div className={style.leftColumn}>
          <FontAwesomeIcon
            onClick={() => toggleDropDownVisibility()}
            className={style.leftIcon}
            icon={isDropDownVisible ? faChevronUp : faChevronDown}
          />
          <p className={style.bold}>
            {t('{{amount}} people', { amount: target.persons.length })}
          </p>
          <p className={style.boldMobile}>
            {t('{{amount}} people', { amount: target.persons.length })}
          </p>
        </div>
        <div className={style.rightColumn1}>
          <p className={style.bold}>
            <Currency>{target.amount}</Currency> {t('(goal)')}
          </p>
          <p className={style.boldMobile}>
            <Currency>{target.amount}</Currency>
          </p>
        </div>
      </div>
      <ul
        className={
          isDropDownVisible ? style.dropDownVisible : style.dropDownInvisible
        }>
        {target.persons.length >= 1 ? (
          target.persons.map(person => {
            const personTotal = calculateTotalPerPerson(person)
            const isThereDataForPerson = personRevenues.some(
              personRevenue => personRevenue.personId === person.id,
            )

            return true === isThereDataForPerson ? (
              <OverviewPerson
                key={person.id}
                person={person}
                personTotal={personTotal}
                target={target}
              />
            ) : (
              <OverviewPerson
                key={person.id}
                person={person}
                personTotal={0}
                target={target}
              />
            )
          })
        ) : (
          <p>{t('No persons have been added to this target.')}</p>
        )}
      </ul>
      <hr className={style.hr} />
      <div className={style.overviewTotal}>
        <div className={style.leftColumn}>
          <p className={style.textNormalScreen}>
            {peopleSucceeded}/{target.persons.length} {t('people succeeded')}
          </p>
          <p className={style.textMobile}>
            {peopleSucceeded}/{target.persons.length}
          </p>
        </div>
        <div className={style.middleColumn}>
          <progress
            className={style.progress}
            value={peopleSucceeded}
            max={target.persons.length}
          />
        </div>
        <div className={style.rightColumn1}>
          <p className={style.textNormalScreen}>
            <Currency>{total}</Currency>
          </p>
          <p className={style.textMobile}>
            <Currency>{total}</Currency>
          </p>
        </div>
        <div className={style.rightColumn2}>
          <p className={style.textNormalScreen}>
            <Percent>{peopleSucceeded / target.persons.length}</Percent>
          </p>
          <p className={style.textMobile}>
            <Percent>{peopleSucceeded / target.persons.length}</Percent>
          </p>
        </div>
      </div>
    </li>
  )
}

export default OverviewTarget
